import { forwardRef, Ref, type SVGProps } from 'react';

const SvgMembershipTierVisionary = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 56 56"
    ref={ref}
    {...props}
  >
    <path
      fill="url(#membership-tier-visionary_svg__a)"
      d="M0 12C0 5.373 5.373 0 12 0h32c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12H12C5.373 56 0 50.627 0 44z"
    />
    <path
      fill="url(#membership-tier-visionary_svg__b)"
      d="M38.633 33.516q0 2.678-2.013 4.58-2.012 1.905-4.843 1.904H17.371v-6.804l4.808-1.954H17.37v-8.758q0-2.694 2.012-4.58 2.013-1.905 4.843-1.904h14.406v6.804l-4.807 1.954h4.807v8.757"
    />
    <defs>
      <linearGradient
        id="membership-tier-visionary_svg__a"
        x1={28}
        x2={28}
        y1={0}
        y2={200.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C7F50A" />
        <stop offset={1} stopColor="#748F06" />
      </linearGradient>
      <linearGradient
        id="membership-tier-visionary_svg__b"
        x1={28.002}
        x2={28.002}
        y1={16}
        y2={81}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#078A7A" />
        <stop offset={1} stopColor="#022420" />
      </linearGradient>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgMembershipTierVisionary);
export default ForwardRef;
